<p>auth works!</p>


<div class="px-0 mx-0 container-fluid">
    
    <!-- <app-navbar></app-navbar> -->
    <router-outlet></router-outlet>

</div>